<div class="flex flex-col gap-4 border-solid border-b border-x-0 border-t-0 border-shui-base-4 pb-8">
    <span class="text-base font-semibold text-shui-text-strong">{{ 'iro.steps.order-details.title' | translate }}</span>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
        <sh-input-text
            [label]="'iro.overview.distributor-account' | translate"
            [value]="distributorDisplay()"
            disabled
        ></sh-input-text>
        <sh-input-text [label]="'iro.overview.cpr-contact' | translate" [value]="cprDisplay()" disabled></sh-input-text>
        <sh-input-text
            [label]="'iro.overview.months-of-inventory' | translate"
            [value]="monthsOfInventory()?.toString() ?? ''"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'iro.overview.mdla-notification-emails' | translate"
            [value]="additionalEmailsDisplay()"
            disabled
        ></sh-input-text>
    </div>
</div>
